import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import { LayoutSplashScreen } from "../../../_metronic";

const AdminPage = lazy(() => import("./admin/AdminPage"));
const GrupoPage = lazy(() => import("./grupo/GrupoPage"));
const EmpresaPage = lazy(() => import("./empresa/EmpresaPage"));
const RelatorioPage = lazy(() => import("./relatorio/RelatorioPage"));
const TagsPadraoPage = lazy(() => import("./tags-padrao/TagsPadraoPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                <Redirect exact from="/" to="/dashboard" />

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/admin" component={AdminPage} />
                <Route path="/grupo" component={GrupoPage} />
                <Route path="/empresa" component={EmpresaPage} />
                <Route path="/relatorio" component={RelatorioPage} />
                <Route path="/tags-padrao" component={TagsPadraoPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
